module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("TABLE OF CONTENTS")])]), _c('h3', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/04_Foreword"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Foreword")]), _vm._v(" by Dr. John Duffy")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Prologue"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Prologue")]), _vm._v(" How This Book Came to Be")])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Part01"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Part I")]), _vm._v(" For All Bodies")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("1.")]), _vm._v(" People in Context")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocd"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter02"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("2.")]), _vm._v(" The Intersections between Our Internal Landscape")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter02"
    }
  }, [_vm._v("and Our Sociopolitical Conditions")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter03"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("3.")]), _vm._v(" Identities")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocd"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter04"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("4.")]), _vm._v(" Welcoming All Parts of Ourselves, Our Inner and")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter04"
    }
  }, [_vm._v("Outer Selves, Our Bodies, All of It!")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("5.")]), _vm._v(" Some Thoughts on Wellness from Different Models")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("6.")]), _vm._v(" Compassion Practices")])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Part II")]), _vm._v(" For the Person Contemplating Suicide")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("1.")]), _vm._v(" You Are Loved—It Is as Simple as That")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("2.")]), _vm._v(" You Are Not Alone")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("3.")]), _vm._v(" Your Pain Is Valid")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("4.")]), _vm._v(" Your Joy Is Valid")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("5.")]), _vm._v(" Everything Is Temporary: A Meditation on Change")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("6.")]), _vm._v(" Moving Forward Is Not Linear")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("7.")]), _vm._v(" Expectations of Others")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocd"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("8.")]), _vm._v(" You Are the One You’ve Been Waiting For:")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Practices for How to Be There for Yourself")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocd"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("9.")]), _vm._v(" There Are People Who Will Understand You:")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Practices for How to Find Your People")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("10.")]), _vm._v(" Practices for Distress Tolerance")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocd"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("11.")]), _vm._v(" Compassion Practices:Treading the Dark Waters")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("of Negativity to Understand Your Soul")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("12.")]), _vm._v(" The Myth of Perfection")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocd"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("13.")]), _vm._v(" Self-Love Is a Practice: It Is Important to Practice")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Even When It Seems Impossible")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocd"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("14.")]), _vm._v(" Honoring Yourself, Your Boundaries, and")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your Own Care")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("15.")]), _vm._v(" Your Reality Is Your Invention")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("16.")]), _vm._v(" Regrets and the Power of “I Am Sorry”")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocd"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("17.")]), _vm._v(" Finding Balance with Extreme Tragedy")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("(What Is Happening in the World)")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("18.")]), _vm._v(" Resilience Is a Superpower")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("19.")]), _vm._v(" Becoming Incredible")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("20.")]), _vm._v(" You Have Something Valuable to Contribute")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("21.")]), _vm._v(" Understanding Wisdom")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("22.")]), _vm._v(" Finding Self-Love")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("23.")]), _vm._v(" Experiencing Both the Scary and the Beautiful")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocd"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("24.")]), _vm._v(" Gratitude for All That Is Wonderful that Is")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honoring You")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("25.")]), _vm._v(" Helping Others, Volunteering, Feeling Compassion")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("26.")]), _vm._v(" Self-Care Practices")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("27.")]), _vm._v(" Nature as Healer")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("28.")]), _vm._v(" Emotional Releases")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("29.")]), _vm._v(" Only You Can Be on Your Life Journey")])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/43_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Part III")]), _vm._v(" For People Supporting a Person Contemplating Suicide")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocd"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("1.")]), _vm._v(" What Is a Crisis vs a Scary, Difficult, or")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Uncomfortable Conversation?")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("2.")]), _vm._v(" Supporting Someone through a Mental Health Crisis")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("3.")]), _vm._v(" Recovering After a Crisis")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("4.")]), _vm._v(" For Survivors of Loss Related to Suicide")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/48_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("5.")]), _vm._v(" Grief")])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/49_Part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Part IV")]), _vm._v(" Asking for Help and Understanding when Someone Asks")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50_Chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("1.")]), _vm._v(" Talking about Trauma Is Important")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/51_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("2.")]), _vm._v(" A Word on Hope")])]), _vm._v(" "), _c('h2', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/52_Part05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Part V")]), _vm._v(" Resource Guide")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/53_Some_Risk_Factors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some Risk Factors")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/54_Circumstances",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Circumstances that Protect Against Suicide Risk")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/55_Warning_Signs",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some Warning Signs")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/56_What_to_Do",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What to Do and When")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/57_Getting",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Getting Someone into a Seventy-Two-Hour Watch")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/58_Quick_Guide",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quick Guide—a Few Ideas on What to Say and Not to Say")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocd"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/59_Organizations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guide to Some of the National Organizations Working on")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/59_Organizations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suicide Awareness and Prevention")])]), _vm._v(" "), _c('h3', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/60_Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix")])]), _vm._v(" "), _c('h3', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/61_Afterword",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('h3', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/62_Reference",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reference Notes/Index/ Reading List")])]), _vm._v(" "), _c('h3', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/63_Gratitude",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Deepest Gratitude")])]), _vm._v(" "), _c('h3', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/64_About_the_Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9cef2874","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0